<template>
  <div class="downloadshare hide-for-print">

    <div class="downloadshare__actions btn-group">
      <div class="downloadshare__actions__link btn" @click="download()">
        <div class="btn-content">
          <div class="btn-content__icon">
            <svg class="btn-content__icon__svg btn__icon downloadshare__actions__link__icon downloadshare__actions__link__icon--download" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 10.5"><g id="Lag_2" data-name="Lag 2"><g id="Layer_1" data-name="Layer 1"><g id="downloadshare"><path class="cls-1" d="M9.66,5,6.56,7.54a.09.09,0,0,1-.11,0L3.34,5"/><line class="cls-1" x1="6.5" y1="7.77" x2="6.5"/><line class="cls-1" y1="10" x2="13" y2="10"/></g></g></g></svg>
          </div>
          <div class="btn-content__value">{{ this.$Strings('downloadTxt') }}</div>
        </div>
      </div>
      <div class="downloadshare__actions__link btn" @click="showShareOptions = !showShareOptions">
        <div class="btn-content">
          <div class="btn-content__icon">
            <svg class="btn-content__icon__svg btn-icon downloadshare__actions__link__icon downloadshare__actions__link__icon--share" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g id="Lag_2" data-name="Lag 2"><g id="Layer_1" data-name="Layer 1"><g id="downloadshare"><path class="cls-1" d="M10.58,6.46v4.93a.11.11,0,0,1-.11.11H.61a.11.11,0,0,1-.11-.11V1.53a.11.11,0,0,1,.11-.11H5.54"/><path class="cls-1" d="M7.38.5h4.05a.07.07,0,0,1,.07.07V4.62"/><line class="cls-1" x1="11.5" y1="0.5" x2="5.08" y2="6.92"/></g></g></g></svg>
          </div>
          <div class="btn-content__value">{{ this.$Strings('shareTxt') }}</div>
          <div class="shareoptions" v-show="showShareOptions">
            <div class="shareoptions__item shareoptions__item--facebook">
              <a target="_blank" v-bind:href="facebookLink"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.02 16.02"><g id="Lag_2" data-name="Lag 2"><g id="Layer_1" data-name="Layer 1"><g id="Icons"><g id="Black"><path id="Facebook" class="cls-1" d="M8.56,16H.88A.88.88,0,0,1,0,15.14V.88A.88.88,0,0,1,.88,0H15.14A.88.88,0,0,1,16,.88V15.14a.88.88,0,0,1-.88.88H11.05V9.82h2.08l.31-2.42H11.05V5.85c0-.7.19-1.18,1.2-1.18h1.28V2.51a17.11,17.11,0,0,0-1.87-.1,2.91,2.91,0,0,0-3.11,3.2V7.4H6.47V9.82H8.56V16Z"/></g></g></g></g></svg></a>
            </div>
            <div class="shareoptions__item shareoptions__item--twitter">
              <a target="_blank" v-bind:href="twitterLink"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.02 13.35"><g id="Lag_2" data-name="Lag 2"><g id="Layer_1" data-name="Layer 1"><g id="Icons"><g id="Black"><path id="Twitter" class="cls-1" d="M16,1.58a6.42,6.42,0,0,1-1.89.53A3.36,3.36,0,0,0,15.58.25a6.47,6.47,0,0,1-2.09.82A3.24,3.24,0,0,0,11.09,0,3.33,3.33,0,0,0,7.81,3.37a3.44,3.44,0,0,0,.08.77A9.25,9.25,0,0,1,1.12.62a3.43,3.43,0,0,0-.44,1.7A3.39,3.39,0,0,0,2.13,5.12,3.23,3.23,0,0,1,.64,4.7v0A3.35,3.35,0,0,0,3.28,8a3.13,3.13,0,0,1-.87.12A3.19,3.19,0,0,1,1.8,8.1a3.3,3.3,0,0,0,3.07,2.34A6.49,6.49,0,0,1,.78,11.88a6.58,6.58,0,0,1-.78,0,9.15,9.15,0,0,0,5,1.51,9.41,9.41,0,0,0,9.35-9.59c0-.15,0-.29,0-.44A6.75,6.75,0,0,0,16,1.58"/></g></g></g></g></svg></a>
            </div>
            <div class="shareoptions__item shareoptions__item--linkedin">
              <a target="_blank" v-bind:href="linkedInLink"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.69 13.35"><g id="Lag_2" data-name="Lag 2"><g id="Layer_1" data-name="Layer 1"><g id="Icons"><g id="Black"><path id="LinkedIn" class="cls-1" d="M14.69,13.35H11.44V8.66c0-1.23-.51-2.07-1.62-2.07A1.64,1.64,0,0,0,8.27,7.7a2.07,2.07,0,0,0-.07.74v4.91H5S5,5,5,4.28H8.2V5.7a2.94,2.94,0,0,1,2.86-1.51c2,0,3.63,1.3,3.63,4.11v5Zm-13-10.2h0A1.58,1.58,0,0,1,0,1.57,1.6,1.6,0,0,1,1.75,0,1.59,1.59,0,0,1,3.47,1.57,1.6,1.6,0,0,1,1.73,3.15ZM.37,4.28H3.23v9.07H.37V4.28Z"/></g></g></g></g></svg></a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- /.downloadshare -->
</template>

<script>
import submit from 'submit-form'

export default {
  name: 'downloadshare',
  props: ['page'],
  data () {
    return {
      showShareOptions: false
    }
  },
  computed: {
    confidenceIntervals () {
      return this.$store.state.confidenceIntervals
    },
    dateRange () {
      return this.$store.state.rangeYearSliderCurrent
    },
    selectedCountries () {
      return this.$store.state.rsc.selected
    },
    selectedAttributes () {
      return this.$store.state.attributes.selected
    },
    facebookLink () {
      return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.shareUrl)
    },
    twitterLink () {
      return 'https://twitter.com/home?status=' + encodeURIComponent(this.shareUrl)
    },
    linkedInLink () {
      return 'https://www.linkedin.com/shareArticle?mini=true&title=The%20Global%20State%20of%20Democracy%20indices&url=' + encodeURIComponent(this.shareUrl)
    },
    shareUrl () {
      let baseurl = location.protocol + '//' + location.host + location.pathname + '#' + this.$route.path + '?'
      let queryParams = []

      if (this.selectedCountries) {
        let countriesArray = []
        for (let country of this.selectedCountries) {
          countriesArray.push(country.id)
        }
        queryParams.push('rsc=' + JSON.stringify(countriesArray))
      }
      if (this.selectedAttributes) { queryParams.push('attr=' + JSON.stringify(this.selectedAttributes)) }
      if (this.dateRange) { queryParams.push('date=' + JSON.stringify(this.dateRange)) }

      queryParams.push('ci=' + this.confidenceIntervals)

      return baseurl + queryParams.join('&')
    }
  },
  methods: {
    download () {
      if (this.page === 'CompareAttributes') {
        this.downloadCompareAttributes()
      } else {
        this.downloadCompareSRC()
      }
    },
    /**
     * Triggers the download
     * @param  {obj} postdata The post data
     * @return {void}
     */
    postDownload (postdata) {
      submit(this.$Strings('image_download_url'), {
        method: 'POST',
        target: '_blank',
        body: postdata
      })
    },

    /**
     * Download compare attributes chart image
     * @return {void}
     */
    downloadCompareAttributes () {
      let svgcharts = document.querySelectorAll('.linechart__svg')
      if (!(svgcharts.length > 0)) {
        alert('An error occured')
      }

      let title = this.$store.getters['rsc/firstSelected'].name
      let svgchart = svgcharts[0].innerHTML
      let years = this.$store.state.rangeYearSliderCurrent
      let attributes = this.$store.state.attributes.selected
      let labels = []

      for (let attr of attributes) {
        let id = this.$store.getters['attributes/labelInfo'](attr, 'id')
        let name = this.$store.getters['attributes/labelInfo'](attr, 'name')
        let color = this.$store.getters.getSelectionColor(attr)

        labels.push({
          id: id,
          name: name,
          color: color
        })
      }

      this.postDownload({
        title: title,
        svg: svgchart,
        labels: JSON.stringify(labels),
        years: JSON.stringify(years)
      })
    },

     /**
     * Download compare src chart image
     * @return {void}
     */
    downloadCompareSRC () {
      let svgcharts = document.querySelectorAll('.linechart__svg')
      if (!(svgcharts.length > 0)) {
        alert('An error occured')
      }

      let firstKey = this.$store.getters['attributes/firstSelected']
      let title = this.$store.getters['attributes/labelInfo'](firstKey, 'name')
      let svgchart = svgcharts[0].innerHTML
      let years = this.$store.state.rangeYearSliderCurrent
      let rscs = this.$store.state.rsc.selected
      let labels = []

      for (let rsc of rscs) {
        labels.push({
          id: rsc.id,
          name: rsc.name,
          color: rsc.color
        })
      }

      this.postDownload({
        title: title,
        svg: svgchart,
        labels: JSON.stringify(labels),
        years: JSON.stringify(years)
      })
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/shared/fonts';
  @import '~@/components/sass/shared/helpers';
  @import '~@/components/sass/components/btns';

  .downloadshare__actions{ text-align: right; }

  .shareoptions{
    background: $gray-darkest;
    display: flex; -js-display: flex;
    left: -5px;
    position: absolute;
    top: -35px;
  }
  .shareoptions:after{
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: transparentize($gray-darkest, 1);
    border-top-color: $gray-darkest;
    border-width: 5px;
    margin-left: -5px;
  }

  .shareoptions__item{
    align-items: center;
    border-left: 1px solid $gray-darkest;
    display: flex; -js-display: flex;
    padding: 5px;

    &:first-child{
      border-left: none;
    }

    SVG{
      width: 15px;
      height: auto;
    }
    .cls-1{fill:#fff;}
  }

  .downloadshare__actions__link{ position: relative; }

  .btn-content__value{
    color: $gray;
    white-space: nowrap;
  }
  .btn .btn-content__icon{ stroke: $gray; }
  .btn:hover .btn-content__value{ color: $gray-darkest; }
  .btn:hover .btn-content__icon{ stroke: $gray-darkest; }

</style>



// WEBPACK FOOTER //
// src/components/shared/misc/DownloadShare.vue